import { isApp } from './isApp';

/**
 *
 * @returns true if Platform 'web'
 */
export const isWeb = () => {
  return !isApp();
};
